import { useMutation, useQueryClient } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useSaveStaffOrder = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      callApi({
        path: "draftorderstaffcard",
        command: "save",
        data: JSON.stringify(data),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["draftOrder"],
      });
      // queryClient.invalidateQueries({
      //   queryKey: ["wardrobeCard"],
      // });
    },
  });
};
